import { computed, inject, Injectable } from '@angular/core';
import { tapSuccess } from '@partners/errors';
import { HttpService } from '@partners/http';
import { coerceNumber, takeOnce } from '@partners/utils';
import { NavigationAdapter } from '../../navigation';
import { PolicyService } from '../../process';

@Injectable({
  providedIn: 'root'
})
export class SimulatorFacade {
  #httpService = inject(HttpService);
  #navAdapter = inject(NavigationAdapter);
  #policyService = inject(PolicyService);

  readonly #simulatorConfig$$ = this.#policyService.findFeatureConfig$$('simulator');

  readonly isLoanAmountReadonly$$ = computed<boolean>(() => {
    const isLoanAmountReadonly = this.#simulatorConfig$$()?.indication['isLoanAmountReadonly'];
    return isLoanAmountReadonly;
  });
  readonly approvedLoanAmount$$ = computed<number>(() => {
    const approvedLoanAmount = this.#simulatorConfig$$()?.text['maxLoanAmount'];
    return coerceNumber(approvedLoanAmount);
  });
  updateLoanAmount({ loanAmount }: { loanAmount: number }) {
    return this.#httpService.post('simulator', { loanAmount }).pipe(
      takeOnce(),
      tapSuccess(() => {
        this.#navAdapter.toSimulator();
      })
    );
  }
}
